<template>
  <v-app>
    <AppCoreHeader />
    <v-main>
      <v-container fluid class="title">
        <slot name="title" />
      </v-container>
      <v-container fluid v-if="display.smAndDown" class="main-visual pa-0">
        <slot name="main-visual" />
      </v-container>
      <v-container class="content pt-0 pt-md-3">
        <v-row>
          <!-- 左側（SP時は先に表示） -->
          <v-col cols="12" lg="8" class="detail mt-sm-3 mx-auto">
            <slot v-if="!display.smAndDown" name="main-visual" />
            <section>
              <slot name="detail" />
            </section>
          </v-col>

          <!-- 右側（SP時は下に移動。PC時はsticky） -->
          <v-col cols="12" lg="4" class="form mx-auto mt-3" id="application">
            <div class="sticky-box">
              <slot name="form" />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <slot />
    </v-main>
    <AppCoreFooter />
    <slot name="bottom-navigation" />
  </v-app>
</template>

<style lang="scss" scoped>
.sticky-box {
  border-radius: 8px;
}

/* md以上の画面で sticky */
@media (min-width: 960px) {
  .sticky-box {
    /* v-app-bar の高さに合わせる */
    top: 4.5rem;
    position: sticky;
  }
}
</style>

<script setup lang="ts">
import '@/assets/scss/seminar_lp/global.scss';
import { useDisplay } from 'vuetify';

const runtimeConfig = useRuntimeConfig();
const display = useDisplay();

useSeoMeta({
  charset: 'utf-8',
  viewport: 'width=device-width, initial-scale=1.0',
  ogType: 'website',
  ogLocale: 'ja_JP',
  ogSiteName: '株式会社C&Rリーガル･エージェンシー社',
  twitterCard: 'summary_large_image',
  twitterSiteId: "CRLA_Co_Ltd",
  appleMobileWebAppTitle: "/favicon.ico",
});
useHead({
  htmlAttrs: {
    lang: 'ja',
  },
  meta: [
    {
      "http-equiv": "x-dns-prefetch-control",
      content: "on",
    },
  ],
  link: [
    {
      key: 'preconnect-gstatic.com',
      rel: 'preconnect dns-prefetch',
      href: '//www.gstatic.com',
    },
    {
      key: 'preconnect-google.com',
      rel: 'preconnect dns-prefetch',
      href: '//www.google.com',
    },
    {
      key: 'preconnect-googletagmanager.com',
      rel: 'preconnect dns-prefetch',
      href: '//www.googletagmanager.com',
    },
    {
      key: 'preconnect-clarity.ms',
      rel: 'preconnect dns-prefetch',
      href: '//www.clarity.ms',
    },
    {
      key: 'preconnect-fonts.gstatic.com',
      rel: 'preconnect dns-prefetch',
      href: '//fonts.gstatic.com',
    },
    {
      key: 'preconnect-fonts.googleapis.com',
      rel: 'preconnect dns-prefetch',
      href: '//fonts.googleapis.com',
    },
    {
      key: 'preconnect-my-host',
      rel: 'preconnect dns-prefetch',
      href: runtimeConfig.public.appUrlOrigin,
    },
    {
      key: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico'
    },
    {
      key: 'shortcut-icon',
      rel: 'shortcut icon',
      href: '/favicon.ico',
    },
  ],
});
</script>